import Component from '@glimmer/component'
import { t } from 'ember-intl'
import { last, initial } from 'lodash'
import type Assignment from 'teacher-ui-client/models/assignment'

interface Args {
  assignment: Assignment
}

interface Signature {
  Args: Args
  Element: HTMLDivElement
}

/**
 * The component to display a description of a book with formatted chapters
 */
export class ActivityDescriptionBook extends Component<Signature> {
  get chapterNames() {
    const chapters = this.args.assignment.assignedChapters ?? []

    if (chapters.length === 0) return ''
    if (chapters.length === 1) return `Chapter ${chapters.join()}`

    const lastChapter = last(chapters) ?? ''
    const trimmedChapters = initial(chapters).join(', ')

    return `Chapters ${trimmedChapters} & ${lastChapter}`
  }

  <template>
    <div ...attributes>
      <strong data-test-description-title class="block text-left font-bold">{{@assignment.title}}</strong>
      <small data-test-description-subtitle class="text-sm">
        {{if
          @assignment.isReadAloudAssignment
          (t "assignments.description.subtitle.readAloud")
          (t "assignments.description.subtitle.libraryQuiz")
        }}
        {{#if this.chapterNames}}
          -
          {{this.chapterNames}}
        {{/if}}
      </small>
    </div>
  </template>
}
